export const BRAND = {
  name: "Ghisa Ram Khandelwal Saraf",
  shortName: "Ghisa Ram Khandelwal",
  tagline: "Pure Silver. Timeless Craftsmanship.",
  subtitle: "Trusted silver jewellers serving generations.",
  establishedYear: 1972,
  city: "Delhi",
  address:
    "9A/1153, Mohini Market, Kucha Mahajani, Chandni Chowk, Delhi, 110006",
  phoneDisplay: "+91 96433 73548",
  phoneRaw: "919643373548",
  instagramHandle: "ghisa_ram_khandelwal_saraf",
  instagramUrl:
    "https://instagram.com/ghisa_ram_khandelwal_saraf",
  facebookHandle: "grkjewellers",
  facebookUrl: "https://www.facebook.com/grkjewellers",
  mapsUrl:
    "https://www.google.com/maps/search/?api=1&query=9A%2F1153%2C+Mohini+Market%2C+Kucha+Mahajani%2C+Chandni+Chowk%2C+Delhi%2C+110006",
  mapsEmbed:
    "https://www.google.com/maps?q=Mohini%20Market%2C%20Kucha%20Mahajani%2C%20Chandni%20Chowk%2C%20Delhi%2C%20110006&output=embed",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_ghisa-ram-silver/artifacts/nw31offs_WhatsApp%20Image%202026-04-27%20at%2021.59.19%20%282%29.jpeg",
  monogramUrl:
    "https://customer-assets.emergentagent.com/job_ghisa-ram-silver/artifacts/nw31offs_WhatsApp%20Image%202026-04-27%20at%2021.59.19%20%282%29.jpeg",
};

export const waLink = (msg) =>
  `https://wa.me/${BRAND.phoneRaw}?text=${encodeURIComponent(
    msg || "Namaste, I'd like to see your latest silver jewellery designs."
  )}`;
